import React from "react";
import { OptionNameValuePair } from "../../../../../lib/interfaces/types";

import { AUTHORITY_DISPLAY_NAMES } from "../../../../../api/observationByAuthority";
import { useAppSelector } from "../../../../../app/store";
import SelectDropdownV2 from "../../../../../components/ui/selectdropdown/v2";
import { getCompetentAuthorities } from "../../../../configs/logic/Slice";

interface CompetentAuthorityDropdownProps {
  value?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const CompetentAuthorityDropdown: React.FC<CompetentAuthorityDropdownProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const competentAuthorityValues = useAppSelector(getCompetentAuthorities);

  const isLoading = !competentAuthorityValues || competentAuthorityValues.length === 0;

  const options: OptionNameValuePair<string>[] = competentAuthorityValues.map((authority) => ({
    name: AUTHORITY_DISPLAY_NAMES[authority as string] ?? authority,
    value: authority,
  }));

  return (
    <div className="flex items-center mb-7">
      <span className="font-sans font-medium text-sm text-[#0A0A0A] mr-3 whitespace-nowrap">Competent Authority</span>
      <SelectDropdownV2
        name="Competent Authority"
        placeholder={isLoading ? "Loading..." : "Select Authority"}
        options={options}
        selectedOption={options.find((o) => o.value === value)}
        onSelectionChange={(opt: any) => onChange(opt.value)}
        containerClassName="w-[324px] h-[36px] rounded-md border border-[#E5E5E5] py-1 px-3 flex items-center"
        labelClassName="h-full"
        disabled={disabled || isLoading}
      />
    </div>
  );
};

export default CompetentAuthorityDropdown;
